import { WaIcon } from "./BrandIcons";
import { useLang } from "@/i18n/LanguageContext";

const WHATSAPP_URL = "https://chat.whatsapp.com/IQw8ZR4gsBIBzh1xJnNyk1";

// Discreet floating WhatsApp bubble — only on French pages.
export const WhatsAppBubble = () => {
  const { lang } = useLang();
  if (lang !== "fr") return null;
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-bubble"
      aria-label="Rejoindre le canal francophone sur WhatsApp"
      title="Rejoindre le canal francophone sur WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-night shadow-lg shadow-[#25D366]/25 transition-transform hover:scale-110"
    >
      <WaIcon size={24} />
    </a>
  );
};

export default WhatsAppBubble;
